import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Image1 from "../assests/github-icon.png";
import Image2 from "../assests/link.png";
import Gold from "../assests/gold.png";
import Artflix from "../assests/artflix.png";
import Zenith from "../assests/zenith.png";

function works() {
  return (
     <Container className='mb-5 mt-5' style={{paddingTop:"20px"}} id="project">
        <Row className='mb-5'>
        <h2 className='text-white mb-5' data-aos="fade-up"><span className='color'>03. &nbsp; &nbsp;</span>Projects I have dveloped</h2>
            <Col data-aos="fade-right" lg={6} md={6} sm={12} xs={12}>  
            <img src={Gold} alt="gold-pie" className="img-fluid" style={{paddingTop:"20px"}}  />
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
            <p className='color mb-3' data-aos="fade-left">Real Time project</p>
           <p className='fs-4 text-white mb-3 ' data-aos="fade-left" style={{fontWeight:"600"}}>Daily Gold Price Analysis</p>
           <Card style={{background:"#0a2351"}} className="mb-3" >
   <p className='font2 color2 py-2 px-3 aligin-items-center' data-aos="fade-left"> Performed daily gold price analysis using 20 years of historical data to identify trends, seasonal patterns, and correlations with economic indicators.Day to Day analysis of the gold price is stored in database and redirects to main page by node js.  </p>
           </Card>
           <Row className="color3">
            <Col data-aos="fade-left">
             <p>Node. js</p>
            </Col>
            <Col data-aos="fade-left">
             <p>Express. js</p>
            </Col>
            <Col data-aos="fade-left">
             <p>Mongo Db</p>
            </Col>
            <Col data-aos="fade-left">
             <p>Gold Api</p>
            </Col>
            <Col data-aos="fade-left">
             <p>Html5/Css</p>
            </Col>
            <Col data-aos="fade-left">
             <p> Javascript</p>
            </Col>
         </Row>
          <a href="https://drive.google.com/drive/folders/1mAYKdNFt8c3au5SEXjGgC4Q4Qq0yIMzc?usp=sharing">  <img className="but1" src={Image1} style={{paddingRight:"18px"}} width={50} alt="gihub-icon"></img> </a> <img className="but1" src={Image2} alt="external-link"></img>
            </Col>
            
        </Row>
        <Row  className='mb-5'>
           <Col lg={6} md={6} sm={12} xs={12}>
            <p data-aos="fade-right" className='color mb-3'>Real Time project</p>
           <p className='fs-4 text-white mb-3 ' data-aos="fade-right" style={{fontWeight:"600"}}>Artflix Company Website</p>
           <Card style={{background:"#0a2351"}} className="mb-3">
   <p className='font2 color2 py-2 px-3 aligin-items-center' data-aos="fade-right"> ArtFlix Design Company Website, focus on promotion, feedback, SEO, content updates, analytics, security, and customer support to maximize effectiveness and user engagement. The Company webiste is developed with user friendly and user experience.  </p>
           </Card>
           <Row className="color3">
            <Col data-aos="fade-right">
             <p>Html5/Css</p>
            </Col>
            <Col data-aos="fade-right">
             <p> Javascript</p>
            </Col>
            <Col data-aos="fade-right">
             <p>AOS</p>
            </Col>
            <Col data-aos="fade-right">
             <p> JQuery</p>
            </Col>
            <Col data-aos="fade-right">
            <p>bootstrap</p>
            </Col>
         </Row>
           <a href="https://github.com/Artflix-Design/Artflix_Website"> <img src={Image1} style={{paddingRight:"18px"}} className="but1" width={50} alt="gihub-icon"></img> </a> <a href="https://artflixdesign.com"> <img src={Image2} alt="external-link" className="but1"></img></a>
            </Col>
         <Col lg={6} md={6} sm={12} xs={12}>  
            <img src={Artflix} data-aos="fade-left" alt="gold-pie" className="img-fluid" style={{paddingTop:"20px"}}  />
            </Col>
          
        </Row>
        <Row  className='mb-5'>
        <Col data-aos="fade-right" lg={6} md={6} sm={12} xs={12}>  
            <img src={Zenith} alt="gold-pie" className="img-fluid" style={{paddingTop:"20px"}}  />
            </Col>
          
           <Col lg={6} md={6} sm={12} xs={12}>
            <p data-aos="fade-left" className='color mb-3'>Real Time project</p>
           <p data-aos="fade-left" className='fs-4 text-white mb-3 ' style={{fontWeight:"600"}}>Zenith Company Website</p>
           <Card style={{background:"#0a2351"}} className="mb-3">
   <p className='font2 color2 py-2 px-3 aligin-items-center' data-aos="fade-left"> I have developed a website using React.js and incorporated appealing visuals with animation effects. It sounds like you've put a lot of effort into creating a visually engaging user experience. I have done  optimizing performance, handling state management in react. </p>
           </Card>
           <Row className="color3">
            <Col data-aos="fade-left">
             <p>Html5/Css</p>
            </Col>
            <Col data-aos="fade-left">
             <p> Javascript</p>
            </Col>
            <Col data-aos="fade-left">
             <p>AOS</p>
            </Col>
            <Col data-aos="fade-left">
             <p> JQuery</p>
            </Col>
            <Col data-aos="fade-left">
            <p>bootstrap</p>
            </Col>
         </Row>
             <img src={Image1} style={{paddingRight:"18px"}} className="but1" width={50} alt="gihub-icon"></img>  <a href="https://best-task.netlify.app"><img src={Image2} className="but1" alt="external-link"></img> </a>
            </Col>
        </Row>
     </Container>
  )
}

export default works
